import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableFooter,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { PiSquaresFour } from "react-icons/pi";
import { sortDates } from "../../utils/timeFuncs";
import TableInput from "../TableInput";
import { IS_LOCAL_ENV } from "../../App";

//=============================table rows methods=================================

const dateExists = (array, fecha) => {
  return array.some((obj) => obj.date === fecha);
};

const totalQuantityByBlockDate = (array, fecha) => {
  const objeto = array.find((obj) => obj.date === fecha);
  return objeto
    ? objeto.comsumptions.reduce((acc, c) => acc + c.quantity, 0)
    : 0;
};

const totalQuantityByBlock = (block, dates) => {
  let total = 0;
  for (const date of dates) {
    if (dateExists(block.blockSDates, date)) {
      total += totalQuantityByBlockDate(block.blockSDates, date);
    }
  }
  return total;
};

//=================================table row's expand section methods======================================
const totalQuantityBySupplie = (block, supplieId) => {
  // Usamos reduce para iterar sobre el array y acumular las quantities del supplie
  return block.blockSDates.reduce((total, obj) => {
    // Buscar el supplie en el arreglo de consumptions del objeto actual
    const consumo = obj.comsumptions.find((c) => c.supplie.id === supplieId);

    // Si se encuentra el supplie, agregar la quantity al total acumulado
    if (consumo) {
      return total + consumo.quantity;
    }

    // Si no se encuentra el supplie, no sumamos nada
    return total;
  }, 0); // El valor inicial de la suma es 0
};

const quantityByBlockSupplieByBlockDate = (block, date, supplieId) => {
  // Buscar el objeto con la fecha indicada
  const objeto = block.blockSDates.find((obj) => obj.date === date);
  IS_LOCAL_ENV && console.log("objeto encontrado: ", objeto);

  // Si se encuentra el objeto, buscar el supplie dentro de 'comsumptions'
  if (objeto) {
    const consumo = objeto.comsumptions.find((c) => c.supplie.id === supplieId);

    // Si se encuentra el supplie, retornar la cantidad
    if (consumo) {
      return consumo.quantity;
    }
  }

  // Si no se encuentra el objeto o el supplie, retornar null o 0 dependiendo de lo que necesites
  return 0;
};

//====================================footer methods===================================================
const totalProgramQuantityByDate = (blocks, date) => {
  let total = 0;
  for (const block of blocks) {
    total += totalQuantityByBlockDate(block.blockSDates, date);
  }
  return total;
};

const totalProgramQuantity = (blocks, dates) => {
  let total = 0;
  for (const date of dates) {
    for (const block of blocks) {
      total += totalQuantityByBlockDate(block.blockSDates, date);
    }
  }
  return total;
};

const formatedDate = (fechaISO) => {
  const fecha = new Date(fechaISO);
  const dia = String(fecha.getUTCDate()).padStart(2, "0");
  const mes = String(fecha.getUTCMonth() + 1).padStart(2, "0"); // Los meses comienzan en 0
  const anio = String(fecha.getUTCFullYear()).slice(-2); // Tomar solo los últimos 2 dígitos del año
  return `${dia}/${mes}/${anio}`;
};

const formatedDate2 = (fechaISO) => {
  // Convertimos la fecha ISO a un objeto Date
  const fecha = new Date(fechaISO);

  // Aplicamos la zona horaria "America/Lima" usando Intl.DateTimeFormat
  const options = {
    timeZone: "America/Lima",
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  };

  const formatted = new Intl.DateTimeFormat("es-PE", options).format(fecha);

  // El formato retornado será 'dd/mm/yy', y ya no necesitas hacer más ajustes
  return formatted;
};

//formato del back:
// {
//   ...season props,
//   blocks:[
//     { (index i)
//         ...block props,
//         blockSDates:[
//           {
//             ...props,
//             date,
//             consumptions:[
//               {
//                 id:supplieId,
//                 quantity:n,
//                 suplie:{
//                   ...supplieInfo
//                 }
//               }
//             ]
//           }
//         ]
//     }
//   ]
// }

const BlockInfoTable = ({ data, seasonNumber, changeQuantity, updCount }) => {
  //modificar para no duplicar data
  //const [data, setData] = useState(data);
  const [header2, setHeader2] = useState([]);
  const [header1, setHeader1] = useState([]);
  const [loading, setLoading] = useState(true);
  const [displayBlockInfo, setDisplayBlockInfo] = useState({});

  //======================================Optimizaciones=========================================
  // Nuevo estado para el input activo
  const [activeInput, setActiveInput] = useState(null);

  // Función para activar o desactivar el input
  const handleCellClick = (rowPos, col, date) => {
    setActiveInput(
      (prev) =>
        prev && prev.rowPos === rowPos && prev.col === col && prev.date === date
          ? null // Si se hace clic en el mismo, lo desactiva
          : { rowPos, col, date } // Activa el nuevo input
    );
  };
  //=============================================================================================

  //===================change some quantity===============

  useEffect(() => {
    let datesObj = {};
    for (const block of data.blocks) {
      block.blockSDates?.map((blockDate) => {
        //datesObj[blockDate.date.split("T")[0]] = true;
        datesObj[blockDate.date] = true;
        console.log(blockDate.date);
      });
    }

    let datesArray = Object.keys(datesObj);
    datesArray = sortDates(datesArray);

    let h1 = ["Suma del total", "Estado", ...Array(datesArray.length).fill("")];
    setHeader1(h1);

    //previamente ordenar las fechas
    let h2 = ["Etiquetas de fila", ...datesArray, "Total general"];
    setHeader2(h2);
    //IMPORTANTE, HEADER2 CONTIENE TODAS LAS FECHAS EXISTENTES SIN REPETICIONES:
    //["etiq...", fecha1, fecha2, ..., fecha n , "total general"]

    //collapseProps
    let newObj = {};
    for (let i = 0; i < data.blocks.length; i++) {
      newObj[data.blocks[i].letter] = false;
    }
    setDisplayBlockInfo(newObj);

    IS_LOCAL_ENV && console.log("data recibida: ", data);
  }, [seasonNumber, updCount]);

  useEffect(() => {
    if (header1.length > 2 && header2.length > 1) {
      setLoading(false);
    }
  }, [header1, header2]);

  const toggleDisplay = (block) => {
    IS_LOCAL_ENV && console.log("click en bloque " + block);
    setDisplayBlockInfo((prevState) => ({
      ...prevState,
      [block]: !prevState[block],
    }));
  };

  if (loading) return <>Cargando datos</>;
  else if (data.status == "hidden")
    return <>Aún no terminas de configurar las fechas e intervalos</>;
  else
    return (
      <Table className="overflow-hidden">
        {/*header 1*/}
        <TableHead
          sx={{ display: "table-header-group", width: "100%" }}
          className="bg-dark-green font-white font-bold"
        >
          <TableRow sx={{ border: 0 }}>
            {header1.map((columnTitle, i) => {
              return (
                <TableCell key={i} align={`${i > 0 ? "right" : ""}`}>
                  <span className="font-poppins font-bold text-white ">
                    {columnTitle}
                  </span>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        {/*header 2*/}
        <TableHead
          sx={{ display: "table-header-group", width: "100%" }}
          className="bg-dark-green font-white font-bold"
        >
          <TableRow sx={{ border: 0 }}>
            {header2.map((columnTitle, i) => {
              return (
                <TableCell key={i} align={`${i > 0 ? "right" : ""}`}>
                  <span className="font-poppins font-bold text-white ">
                    {columnTitle != "Etiquetas de fila" &&
                    columnTitle != "Total general"
                      ? new Date(columnTitle).toLocaleDateString()
                      : columnTitle}
                  </span>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody className="font-poppins text-dark-green">
          {data.blocks.map((block, i) => {
            return (
              <>
                <TableRow
                  key={i}
                  onClick={(e) => toggleDisplay(block.letter)}
                  className="hover:cursor-pointer"
                >
                  {header2.map((date, j) => {
                    return (
                      <TableCell key={j} align={`${j > 0 ? "right" : ""}`}>
                        {j == 0 ? (
                          <span className="flex flex-row text-nowrap font-bold items-center ">
                            <PiSquaresFour className="text-accent-green m-1 w-[25px] h-[25px] " />
                            <span className="text-dark-green font-poppins">
                              Bloque {" " + block.letter}
                            </span>
                          </span>
                        ) : j == header2.length - 1 ? (
                          <span className=" font-poppins text-dark-green font-bold">
                            {
                              totalQuantityByBlock(
                                block,
                                header2.slice(1, -1)
                              ) /* header2.slice(1, -1) contiene unicamente las fechas sin repeticiones */
                            }
                          </span>
                        ) : dateExists(block.blockSDates, date) ? (
                          <span className=" font-poppins text-dark-green font-bold">
                            {totalQuantityByBlockDate(block.blockSDates, date)}
                          </span>
                        ) : (
                          ""
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>

                {displayBlockInfo[block.letter] &&
                  block.supplies.map((supplie, k) => {
                    return (
                      <TableRow
                        sx={{ height: 30 }}
                        className="bg-light-green-50 text-dark-green"
                      >
                        {header2.map((date, m) => {
                          return (
                            <TableCell
                              key={m}
                              sx={{
                                minHeight: 30,
                                paddingY: `8px`,
                                // paddingX: `${m == 0 ? "0px" : "12px"}`,
                              }}
                              align={`${m > 0 ? "right" : ""}`}
                            >
                              {m == 0 ? (
                                <span className="font-bold font-poppins text-dark-green  text-nowrap ml-[40px]">
                                  {supplie.sName}
                                </span>
                              ) : m == header2.length - 1 ? (
                                <span className=" font-poppins text-dark-green">
                                  {totalQuantityBySupplie(block, supplie.id)}
                                </span>
                              ) : dateExists(block.blockSDates, date) ? (
                                // Solo renderiza el input en la celda activa
                                activeInput &&
                                activeInput.rowPos === i &&
                                activeInput.col === supplie.id &&
                                activeInput.date === date ? (
                                  <span className=" font-poppins text-dark-green flex justify-end ">
                                    <TableInput
                                      //updatingBlock={updatingBlock} //para disablear edicion
                                      rowPos={i} //posicion del bloque
                                      col={supplie.id} //en este caso, envio la medicina
                                      updValue={changeQuantity}
                                      props={{ type: "number", min: 0 }}
                                      value={quantityByBlockSupplieByBlockDate(
                                        block,
                                        date,
                                        supplie.id
                                      )}
                                      w="w-[50px]"
                                      extraProp={date} //only for this table
                                    />
                                  </span>
                                ) : (
                                  <span
                                    className=" font-poppins  text-sm text-dark-green flex justify-end"
                                    onClick={() =>
                                      handleCellClick(i, supplie.id, date)
                                    }
                                  >
                                    <span className="w-fit hover:bg-simple-gray p-[2px] rounded-[4px] hover:cursor-pointer">
                                      {quantityByBlockSupplieByBlockDate(
                                        block,
                                        date,
                                        supplie.id
                                      )}
                                    </span>
                                  </span>
                                )
                              ) : (
                                ""
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </>
            );
          })}
        </TableBody>
        <TableFooter
          sx={{ width: "100%" }}
          className="bg-dark-green font-white font-bold"
        >
          <TableRow>
            {header2.map((date, m) => {
              return (
                <TableCell key={m} align={`${m > 0 ? "right" : ""}`}>
                  {m == 0 ? (
                    <span className="font-bold text-base font-poppins text-white text-nowrap mr-[40px]">
                      Total General
                    </span>
                  ) : m == header2.length - 1 ? (
                    <span className=" font-poppins text-white font-bold text-base">
                      {totalProgramQuantity(data.blocks, header2.slice(1, -1))}
                    </span>
                  ) : (
                    //evaluar existencia antes de renderizar
                    <span className=" font-poppins text-white font-bold text-base">
                      {totalProgramQuantityByDate(data.blocks, date)}
                    </span>
                  )}
                </TableCell>
              );
            })}
          </TableRow>
        </TableFooter>
      </Table>
    );
};

export default BlockInfoTable;
